// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer_V6zml","footerAuth":"Footer_footerAuth_bAQDS","footerDiv":"Footer_footerDiv_3cN7S","dateDiv":"Footer_dateDiv_3uVpD","copyright":"Footer_copyright_3JmOu"};